import { render, staticRenderFns } from "./RuleInstruction.vue?vue&type=template&id=25d6176b&scoped=true&"
import script from "./RuleInstruction.vue?vue&type=script&lang=js&"
export * from "./RuleInstruction.vue?vue&type=script&lang=js&"
import style0 from "./RuleInstruction.vue?vue&type=style&index=0&id=25d6176b&lang=scss&scoped=true&"
import style1 from "./RuleInstruction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d6176b",
  null
  
)

export default component.exports